/**
 * 特集コレクション(トップページ)を商品DBの並び順で並べ替える
 * ===========================================================================
 * 2026-08-30 追加。
 *
 * 【何をするのか】
 * `featured-collection-custom` セクションは、コレクションの商品を**全部**出力して
 * おき(最大 data-cap 件)、この JS が商品DBの並び順で並べ替えたうえで、
 * 先頭 data-show 件だけを残して残りを隠す。
 *
 * 【なぜこうするのか】
 * もともとは商品メタフィールド `custom.sort` の小さい順に Liquid で並べていたが、
 * **3店で「並び順はメタフィールドに置かない(二重管理を避ける)」と決めている**ため、
 * コレクション一覧ページ(`collection-sort-order.js`)と同じく、商品DBの
 * `sort_order_feed.php` から読む方式に統一した。
 *
 * 【並び順のもとになるデータ】
 *   https://cran777.velvet.jp/products/sort_order_feed.php
 *   → { "orders": { "代表コード(=商品ハンドル)": 番号, ... } } を返す
 *   番号が小さいほど先頭。**番号が無い商品は末尾**に回す。
 *
 * 【ちらつき防止】
 * 並べ替えが終わるまで `.featured-sort-pending` で透明にしておく。
 *   ・opacity なので場所は確保され、表示が飛び跳ねない
 *   ・JSを切っている人には noscript 側のCSSが効いて、最初から見える
 *   ・通信に失敗しても finish() で必ず表示に戻す(そのときは出力順のまま)
 *
 * 【関連】
 *   コレクション一覧ページ用は collection-sort-order.js(考え方は同じ)。
 *   サーバー側は 商品DB の sort_order_feed.php。
 */
(function () {
  'use strict';

  var FEED_URL = 'https://cran777.velvet.jp/products/sort_order_feed.php';
  var NO_ORDER = 9999999999; // 並び順が無い商品を末尾に回すための大きな数
  var feedPromise = null;

  /** 並び順を1回だけ取りに行き、以後は使い回す */
  function loadOrders() {
    if (feedPromise) return feedPromise;
    feedPromise = fetch(FEED_URL)
      .then(function (res) {
        if (!res.ok) throw new Error('feed status ' + res.status);
        return res.json();
      })
      .then(function (data) {
        return data && data.orders ? data.orders : null;
      })
      .catch(function () {
        return null; // 取れなくても表示は続ける
      });
    return feedPromise;
  }

  /** カード内の商品リンクから代表コード(ハンドル)を取り出す */
  function handleOf(item) {
    if (item.dataset && item.dataset.handle) return item.dataset.handle;
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /** 並べ替えをやめて、とにかく表示だけは正しくする */
  function finish(list) {
    var show = parseInt(list.getAttribute('data-show'), 10) || 0;
    var items = Array.prototype.slice.call(list.children);
    if (show > 0) {
      items.forEach(function (item, i) {
        if (i >= show) item.remove();
      });
    }
    list.classList.remove('featured-sort-pending');
  }

  function sortList(list, orders) {
    if (!orders) {
      finish(list);
      return;
    }
    var items = Array.prototype.slice.call(list.children);
    var decorated = items.map(function (item, index) {
      var handle = handleOf(item);
      var order = handle && Object.prototype.hasOwnProperty.call(orders, handle)
        ? Number(orders[handle])
        : NO_ORDER;
      if (!isFinite(order)) order = NO_ORDER;
      // 並び順が同じときは元の順番を保つ(安定ソートにする)
      return { item: item, order: order, index: index };
    });

    decorated.sort(function (a, b) {
      if (a.order !== b.order) return a.order - b.order;
      return a.index - b.index;
    });

    var frag = document.createDocumentFragment();
    decorated.forEach(function (d) {
      frag.appendChild(d.item);
    });
    list.appendChild(frag);

    finish(list);
  }

  function run() {
    var lists = document.querySelectorAll('ul[data-featured-sort]');
    if (!lists.length) return;
    loadOrders().then(function (orders) {
      Array.prototype.forEach.call(lists, function (list) {
        try {
          sortList(list, orders);
        } catch (e) {
          finish(list);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // テーマエディタでセクションを編集したときにも効かせる
  document.addEventListener('shopify:section:load', run);
})();
